import React from 'react';
import cn from 'classnames';
import button from './Button.module.scss';

const Button = (props) => {
  const {
    children,
    className,
    secondaryClassName,
    stringClassName,
    tagName: TagName,
    name,
    variant,
    type,
    disabled,
    onClick,
    ...rest
  } = props;
  return (
    <TagName
      className={cn(button.btn, 'button', {
        [button[`btn_${variant}`]]: !!variant,
        [button[`${className}`]]: !!className,
        [button[`${secondaryClassName}`]]: !!secondaryClassName,
        [stringClassName]: !!stringClassName,
      })}
      type={type}
      disabled={disabled}
      onClick={onClick}
      {...rest}
    >
      <span>
        {children}
        {name}
      </span>
    </TagName>
  );
};

Button.defaultProps = {
  tagName: 'button',
  type: 'button'
};

export default Button;
